import React, { useContext, useState, useEffect } from 'react';

// Components
import EventDayTabs from '../../_molecules/EventDayTabs';
import SearchSessionsForDay from '../../searches/SearchSessionsForDay';

// Helpers
import { EventDetailProvider } from '../../pages/MyIcsc/Events/EventDetailProvider';
import useEventSessionsTabsStartDate from '../../../hooks/useEventSessionsTabsStartDate';

const EventSessionsList = () => {
    const { event } = useContext(EventDetailProvider);
    const { eventSessionsTabsStartDate } = useEventSessionsTabsStartDate(event);
    const [activeDay, setActiveDay] = useState(eventSessionsTabsStartDate);

    useEffect(() => {
        setActiveDay(eventSessionsTabsStartDate);
    }, [eventSessionsTabsStartDate]);

    return (
        <EventDayTabs
            eventStartDate={eventSessionsTabsStartDate}
            eventEndDate={event.meeting_end_time}
            activeDay={activeDay}
            onDayChange={setActiveDay}
        >
            <SearchSessionsForDay event={event} activeDay={activeDay} />
        </EventDayTabs>
    );
};

export default EventSessionsList;
